export default __webpack_public_path__ + "static/media/Bangle of the Primal Spirit.685dc4b9.jpg";